import React, { useState, useRef, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import handleViewport from 'react-in-viewport';

import { useDispatch, useSelector } from 'react-redux';
import { ClipLoader } from 'react-spinners';

import Swal from 'sweetalert2';
import { Col, Row, Radio, Alert } from 'antd';
import { useFormik } from 'formik';

import history from '~/services/history';

import * as actions from '~/store/modules/careLines/actions';
import { Input } from '~/components/Input';
import Breadcumbs from '~/components/Breadcumbs';
import ErrorField from '~/components/ErrorField';

import { LcScaSchema } from '~/utils/schemas/lcScaSchema';
import {
  numbersAndComa,
  onlyNumbers,
  scrollPageTo,
} from '~/helpers/generalFunctions';

// Components linhas de cuidado
import DadoFaltantes from '../components/DadosFaltantes';

import { RadioInput, RadioInputFlex } from '../components/RadioInput';

import { modalConfirm } from '../../LinhasDeCuidadoFormulario/dados/optionsModal';

import {
  conveniosPaciente,
  tempoInicioSintomas,
  outraInstituicao,
  dataHoraChegada,
  dataHoraEletro,
  classificacaoSca,
  situacaoAdmissao,
  dadosSca,
  motivoSaida,
  eletrocardiograma,
  tratamentoRealizado,
  paliativos,
  saidaEmergencia,
  medicacoesAlta,
  reinternacao,
  reinternacaoMotivo,
  terapiaFibrinolitica,
  angioplastia,
  fracaoDeEjecao,
  covidSca,
} from './options';

import {
  PageTitle,
  BoxContent,
  Content,
  TitleSection,
  BoxInput,
  Label,
  BoxRadios,
  BoxForm,
  ButtonBox,
} from '../styles/style';
import ButtonBack from '~/components/ButtonBack';
import ButtonReset from '../components/ButtonReset';
import ExceptionsForm from '../components/ExceptionsForm';
import { getTitleIndicador } from '../careLinesInfo';

import api from '~/services/api';
import { IoMdHelpCircle } from 'react-icons/io';

const FichadeColetaSCA = ({ location }) => {
  const dispath = useDispatch();

  const { token } = useSelector(state => state.auth);

  const { id } = location?.state || '';

  const { careLineData, loading, errorData } = useSelector(
    state => state.careLines
  );

  const [graceScore, setGraceScore] = useState('');

  const firstFocus = useRef(null);

  const [dados, setDados] = useState(null);

  useEffect(() => {
    // limpa erros
    dispath(
      actions.scaFailure({
        errorData: null,
      })
    );
  }, []);

  useEffect(() => {
    if (location?.state?.id) {
      dispath(actions.scaGetRequest({ id }));
    }
  }, [location?.state]);

  const callHandleSubmit = useCallback(() => {
    Swal.fire(modalConfirm).then(result => {
      if (result.value) {
        formik.handleSubmit();
      }
    });
  }, []);

  useEffect(() => {
    scrollPageTo(75);
  }, []);

  useEffect(() => {
    if (id && careLineData) {
      setDados(careLineData);
    }
  }, [careLineData]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      num_registro_sca: dados?.num_registro_sca?.toString() || null,
      sexo_sca: dados?.sexo_sca?.toString() || null,
      dn_sca: dados?.dn_sca?.toString() || null,
      convenio_sca: dados?.convenio_sca?.toString() || null,
      sintomas_data_sca: dados?.sintomas_data_sca?.toString() || null,
      sintomas_hora_sca: dados?.sintomas_hora_sca?.toString() || null,
      outra_instituicao_sca: dados?.outra_instituicao_sca?.toString() || null,
      entrada_data_sca: dados?.entrada_data_sca?.toString() || null,
      entrada_hora_sca: dados?.entrada_hora_sca?.toString() || null,
      ecg_data_sca: dados?.ecg_data_sca?.toString() || null,
      ecg_hora_sca: dados?.ecg_hora_sca?.toString() || null,
      classificacao_sca: dados?.classificacao_sca?.toString() || null,
      fc_sca: dados?.fc_sca?.toString() || null,
      pas_sca: dados?.pas_sca?.toString() || null,
      creatinina_sca: dados?.creatinina_sca?.toString() || null,
      pcr_sca: dados?.pcr_sca?.toString() || null,
      enzimas_sca: dados?.enzimas_sca?.toString() || null,
      killip_sca: dados?.killip_sca?.toString() || null,
      st_sca: dados?.st_sca?.toString() || null,
      grace_sca: dados?.grace_sca?.toString() || null,
      tto_sca: dados?.tto_sca?.toString() || null,
      fibrinolitico_data_sca: dados?.fibrinolitico_data_sca?.toString() || null,
      fibrinolitico_hora_sca: dados?.fibrinolitico_hora_sca?.toString() || null,
      angioplastia_data_sca: dados?.angioplastia_data_sca?.toString() || null,
      angioplastia_hora_sca: dados?.angioplastia_hora_sca?.toString() || null,
      fe_sca: dados?.fe_sca?.toString() || null,
      paliativos_sca: dados?.paliativos_sca?.toString() || null,
      covid_sca: dados?.covid_sca?.toString() || null,
      saida_motivo_sca: dados?.saida_motivo_sca?.toString() || null,
      saida_data_sca: dados?.saida_data_sca?.toString() || null,
      saida_hora_sca: dados?.saida_hora_sca?.toString() || null,
      estatina_sca: dados?.estatina_sca?.toString() || null,
      bb_sca: dados?.bb_sca?.toString() || null,
      iecabra_sca: dados?.iecabra_sca?.toString() || null,
      reinternacao_sca: dados?.reinternacao_sca?.toString() || null,
      reinternacao_motivo_sca:
        dados?.reinternacao_motivo_sca?.toString() || null,
    },
    validationSchema: LcScaSchema,

    onSubmit: async values => {
      if (id) {
        const payload = {
          ...dados,
          ...values,
        };

        // limpa erros
        dispath(
          actions.scaFailure({
            errorData: null,
          })
        );

        return dispath(
          actions.scaUpdateRequest({
            data: payload,
            id: id,
            periodo: location?.state?.periodo,
          })
        );
      }
      dispath(
        actions.scaRequest({
          data: values,
          periodo: location?.state?.periodo,
        })
      );
    },
  });

  // Lógica de Ramificação:
  const [ramificacao1, setRamificacao1] = useState(false);
  const [ramificacao2, setRamificacao2] = useState(false);
  const [ramificacao3, setRamificacao3] = useState(false);
  const [ramificacao4, setRamificacao4] = useState(false);
  const [ramificacao5, setRamificacao5] = useState(false);

  const exibeRamificacao1 = useCallback((name, value) => {
    if (name == 'classificacao_sca') {
      if (value !== '4' && value !== null) {
        setRamificacao1(true);
      } else {
        setRamificacao1(false);
        formik.setFieldValue('fc_sca', null);
        formik.setFieldValue('pas_sca', null);
        formik.setFieldValue('creatinina_sca', null);
        formik.setFieldValue('pcr_sca', null);
        formik.setFieldValue('enzimas_sca', null);
        formik.setFieldValue('killip_sca', null);
        formik.setFieldValue('tto_sca', null);
        formik.setFieldValue('paliativos_sca', null);
        formik.setFieldValue('fe_sca', null);
        formik.setFieldValue('saida_motivo_sca', null);
        formik.setFieldValue('saida_data_sca', null);
        formik.setFieldValue('saida_hora_sca', null);
        formik.setFieldValue('estatina_sca', null);
        formik.setFieldValue('bb_sca', null);
        formik.setFieldValue('iecabra_sca', null);
      }
      formik.setFieldValue('classificacao_sca', value);
    }
  }, []);

  const exibeRamificacao2 = useCallback((name, value) => {
    if (name == 'reinternacao_sca') {
      if (value == '1') {
        setRamificacao2(true);
      } else {
        setRamificacao2(false);
        formik.setFieldValue('reinternacao_motivo_sca', null);
      }
      formik.setFieldValue('reinternacao_sca', value);
    }
  }, []);

  const exibeRamificacao3 = useCallback(
    (name, value) => {
      if (name == 'saida_motivo_sca') {
        if (value !== '2' && value !== null) {
          setRamificacao3(true);
        } else {
          setRamificacao3(false);
          setRamificacao2(false);
          formik.setFieldValue('reinternacao_motivo_sca', null);
          formik.setFieldValue('reinternacao_sca', null);
        }
        formik.setFieldValue('saida_motivo_sca', value);
      }
    },
    [formik, setRamificacao3, setRamificacao2]
  );

  useEffect(() => {
    exibeRamificacao3('saida_motivo_sca', formik?.values?.saida_motivo_sca);
  }, [formik?.values?.saida_motivo_sca]);

  const exibeRamificacao4 = useCallback((name, value) => {
    if (name === 'tto_sca') {
      if (value == '1') {
        setRamificacao4(true);
        setRamificacao5(false);
        formik.setFieldValue('angioplastia_data_sca', null);
        formik.setFieldValue('angioplastia_hora_sca', null);
      } else if (value == '2') {
        setRamificacao5(true);
        setRamificacao4(false);
        formik.setFieldValue('fibrinolitico_data_sca', null);
        formik.setFieldValue('fibrinolitico_hora_sca', null);
      } else {
        setRamificacao4(false);
        setRamificacao5(false);
        formik.setFieldValue('fibrinolitico_data_sca', null);
        formik.setFieldValue('fibrinolitico_hora_sca', null);
        formik.setFieldValue('angioplastia_data_sca', null);
        formik.setFieldValue('angioplastia_hora_sca', null);
      }
    }
    formik.setFieldValue(`${name}`, value);
  }, []);

  useEffect(() => {
    if (
      dados?.classificacao_sca == '1' ||
      dados?.classificacao_sca == '2' ||
      dados?.classificacao_sca == '3'
    ) {
      setRamificacao1(true);
    }
    if (dados?.reinternacao_sca == '1') {
      setRamificacao2(true);
    }
    if (
      dados?.saida_motivo_sca == '1' ||
      dados?.saida_motivo_sca == '3' ||
      dados?.saida_motivo_sca == '4'
    ) {
      setRamificacao3(true);
    }
    if (dados?.tto_sca == '1') {
      setRamificacao4(true);
    }
    if (dados?.tto_sca == '2') {
      setRamificacao5(true);
    }
  }, [dados]);

  // Reset Button
  const [isLoaded, setIsloaded] = useState(false);

  const handleResetGroup = useCallback(group => {
    group.map(item => {
      formik.setFieldValue(`${item.name}`, null);
      exibeRamificacao1(`${item.name}`, null);
      exibeRamificacao2(`${item.name}`, null);
      exibeRamificacao3(`${item.name}`, null);
      exibeRamificacao4(`${item.name}`, null);
    });
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setIsloaded(true);
    }, 2000);
  }, []);

  // End Reset Button

  useEffect(() => {
    const keyErrors = Object.keys(formik.errors);
    if (keyErrors.length > 0 && formik.isSubmitting) {
      setTimeout(() => {
        const errorElement = document.querySelector(`[name="${keyErrors[0]}"]`);
        if (errorElement)
          errorElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 500);
    }
  }, [formik.submitCount, formik.errors]);

  useEffect(() => {
    scrollPageTo(75);
  }, []);

  useEffect(() => {
    if (formik.submitCount > 0 && Object.entries(formik.errors).length > 0) {
      scrollPageTo(500);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.submitCount]);

  const callGraceScore = useCallback(async () => {
    if (
      formik.values.dn_sca &&
      formik.values.entrada_data_sca &&
      formik.values.fc_sca &&
      formik.values.pas_sca &&
      formik.values.creatinina_sca &&
      formik.values.pcr_sca &&
      formik.values.enzimas_sca &&
      formik.values.killip_sca &&
      formik.values.st_sca
    ) {
      const graceData = {
        dn_sca: formik.values.dn_sca,
        entrada_data_sca: formik.values.entrada_data_sca,
        fc_sca: formik.values.fc_sca,
        pas_sca: formik.values.pas_sca,
        creatinina_sca: formik.values.creatinina_sca,
        pcr_sca: formik.values.pcr_sca,
        enzimas_sca: formik.values.enzimas_sca,
        killip_sca: formik.values.killip_sca,
        st_sca: formik.values.st_sca,
      };
      const endpoint =
        'indicadores-linhas-de-cuidado/sindrome_coronariana_aguda/calculate-grace-score';
      try {
        const response = await api.post(endpoint, graceData, {
          headers: {
            Authorization: token,
          },
        });
        setGraceScore(response.data);
      } catch (error) {
        //
      }
    }
  }, [
    formik.values.dn_sca,
    formik.values.entrada_data_sca,
    formik.values.fc_sca,
    formik.values.pas_sca,
    formik.values.creatinina_sca,
    formik.values.pcr_sca,
    formik.values.enzimas_sca,
    formik.values.killip_sca,
    formik.values.st_sca,
  ]);

  const GraceInput = ({ inViewport, forwardedRef }) => {
    return <div className="viewport-block" ref={forwardedRef} />;
  };

  const GraceInViewport = handleViewport(GraceInput);

  const getErrosPdf = useCallback(() => {
    const { indicador } = location.state;
    history.push({
      pathname: `/area-de-suporte`,
      state: {
        searchBy: `${getTitleIndicador(indicador)}`,
      },
    });
  }, []);

  return (
    <>
      <Breadcumbs
        path="sindrome_coronariana_aguda"
        pathTitle="Adicionar Indicadores de Linhas de Cuidado / SCA"
      />
      <PageTitle>
        <div>
          <ButtonBack />
          <span ref={firstFocus}>Ficha de coleta</span>
        </div>

        {errorData?.fields && isLoaded && (
          <button className="errorButton" type="button" onClick={getErrosPdf}>
            <IoMdHelpCircle size={16} color="#FFF" />
            Documentação de erros
          </button>
        )}
      </PageTitle>

      {loading ? (
        <BoxContent>
          <div className="boxSpin">
            <ClipLoader size={50} color="#74a50a" loading={loading} />
          </div>
        </BoxContent>
      ) : (
        <BoxContent>
          <div className="title">
            <h2>Preencha abaixo as informações:</h2>
          </div>

          <div className="BoxErros">
            {errorData?.fields && (
              <ExceptionsForm
                lc="sindrome_coronariana_aguda"
                exceptions={errorData?.fields}
              />
            )}
          </div>

          <Content>
            <form onSubmit={formik.handleSubmit} method="post">
              {/* Linha de Cuidado, Competência e Dados Gerais */}
              <BoxForm>
                <Row>
                  <Col span={24}>
                    <BoxInput>
                      <Col span={12} className="item">
                        <TitleSection className="font-green">
                          {'>'} Linha de Cuidado
                        </TitleSection>
                        <input
                          type="text"
                          name="indicadorNome"
                          defaultValue={location?.state?.indicadorNome || ''}
                          disabled
                        />
                      </Col>
                      <Col span={12} className="item">
                        <TitleSection className="font-green">
                          {'>'} Competência
                        </TitleSection>
                        <input
                          type="text"
                          name="periodo"
                          defaultValue={location?.state?.periodo || ''}
                          disabled
                        />
                      </Col>
                    </BoxInput>
                  </Col>
                </Row>

                <hr />

                <Row>
                  <Col span={24}>
                    <Row>
                      <Col span={12}>
                        <TitleSection>
                          {'>'} Dados Gerais do paciente
                        </TitleSection>
                      </Col>
                    </Row>

                    <Row>
                      <Col span={12} className="item">
                        <Input
                          name="num_registro_sca"
                          label="1) Número do registro"
                          type="text"
                          // placeholder="Número do registro"
                          value={formik.values.num_registro_sca}
                          maxLength={5}
                          hasError={
                            formik.errors.num_registro_sca &&
                            formik.touched.num_registro_sca
                              ? formik.errors.num_registro_sca
                              : ''
                          }
                          onChange={({ target }) => {
                            formik.setFieldValue(
                              'num_registro_sca',
                              onlyNumbers(target.value)
                            );
                          }}
                        />
                      </Col>
                      <Col span={12} className="item">
                        <Row>
                          <Col span={12}>
                            <Label>2{')'} Sexo</Label>
                          </Col>
                          <Col span={12}>
                            {isLoaded && (
                              <ButtonReset
                                resetGroup={[{ name: 'sexo_sca' }]}
                                handleResetGroup={handleResetGroup}
                              />
                            )}
                          </Col>
                        </Row>
                        <BoxInput>
                          <div className="inlineRadios">
                            <BoxRadios
                              className="v-large"
                              active={formik.values.sexo_sca === '1'}
                            >
                              <Radio
                                name="sexo_sca"
                                value="1"
                                checked={formik.values.sexo_sca === '1'}
                                onChange={() =>
                                  formik.setFieldValue('sexo_sca', '1')
                                }
                              >
                                Feminino
                              </Radio>
                            </BoxRadios>
                            <BoxRadios
                              className="v-large"
                              active={formik.values.sexo_sca === '0'}
                            >
                              <Radio
                                name="sexo_sca"
                                value="0"
                                checked={formik.values.sexo_sca === '0'}
                                onChange={() =>
                                  formik.setFieldValue('sexo_sca', '0')
                                }
                              >
                                Masculino
                              </Radio>
                            </BoxRadios>
                          </div>
                        </BoxInput>

                        {formik.errors.sexo_sca && formik.submitCount > 0 ? (
                          <ErrorField message={formik.errors.sexo_sca} />
                        ) : null}
                      </Col>
                    </Row>
                  </Col>

                  <Col span={24}>
                    <Row>
                      <Col span={12} className="item">
                        <DadoFaltantes
                          title="3) Data de nascimento"
                          name="dn_sca"
                          formik={formik}
                          hasError={
                            formik.errors.dn_sca && formik.submitCount > 0
                              ? formik.errors.dn_sca
                              : ''
                          }
                        />
                      </Col>

                      <Col span={12} className="item">
                        {conveniosPaciente.map(item => (
                          <RadioInputFlex
                            key={`${item.id}-${item.name}`}
                            item={item}
                            formik={formik}
                          />
                        ))}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </BoxForm>
              <hr />

              {/* Dados específicos da linha de cuidado */}
              <Row>
                <Col span={24}>
                  <Row>
                    <TitleSection>
                      {'>'} Dados da doença e do tratamento
                    </TitleSection>
                  </Row>
                  <Row>
                    <h4>5) Data e hora do início dos sintomas</h4>
                  </Row>
                  <Row>
                    {tempoInicioSintomas.map(item => (
                      <Col span={12} className="item" key={item.id}>
                        <DadoFaltantes
                          title={item.label}
                          name={item.name}
                          formik={formik}
                          errors={formik.errors}
                          hasError={
                            formik.errors[item.name] && formik.submitCount > 0
                              ? formik.errors[item.name]
                              : ''
                          }
                        />
                      </Col>
                    ))}
                  </Row>
                </Col>
              </Row>
              <hr />

              {/* Paciente proveniente de outra instituição */}
              <Row>
                {outraInstituicao.map(item => (
                  <RadioInput
                    key={`${item.id}-${item.name}`}
                    item={item}
                    reset
                    formik={formik}
                  />
                ))}
              </Row>
              <hr />

              {/* Data e hora da chegada na instituição */}
              <Row>
                <Col span={24}>
                  <Row>
                    <h4>7{')'} Data e hora da chegada na instituição</h4>
                  </Row>
                  <Row>
                    {dataHoraChegada.map(item => (
                      <Col span={12} className="item" key={item.id}>
                        <DadoFaltantes
                          title={item.label}
                          name={item.name}
                          formik={formik}
                          errors={formik.errors}
                          hasError={
                            formik.errors[item.name] && formik.submitCount > 0
                              ? formik.errors[item.name]
                              : ''
                          }
                        />
                      </Col>
                    ))}
                  </Row>
                </Col>
              </Row>
              <hr />

              {/* Data e hora da realização do primeiro eletrocardiograma na instituição */}

              <Row>
                <Col span={24}>
                  <Row>
                    <h4>
                      8{')'} Data e hora da realização do primeiro
                      eletrocardiograma na instituição
                    </h4>
                  </Row>
                  <Row>
                    {dataHoraEletro.map(item => (
                      <Col span={12} className="item" key={item.id}>
                        <DadoFaltantes
                          title={item.label}
                          name={item.name}
                          formik={formik}
                          errors={formik.errors}
                          firstReason="Dado faltante"
                          secondReason="ECG realizado antes da chegada na instituição"
                          hasError={
                            formik.errors[item.name] && formik.submitCount > 0
                              ? formik.errors[item.name]
                              : ''
                          }
                        />
                      </Col>
                    ))}
                  </Row>
                </Col>
              </Row>

              <hr />

              {/* Classificação da SCA */}
              <Row>
                <Col span={24}>
                  {classificacaoSca.map(item => (
                    <BoxInput key={item.id}>
                      <div className="inlineRadios">
                        <Row>
                          <div style={{ minHeight: '38px' }}>
                            <Row>
                              <Col span={12}>
                                <Label>{item.label}</Label>
                              </Col>
                              <Col span={12}>
                                {isLoaded && (
                                  <ButtonReset
                                    resetGroup={[...classificacaoSca]}
                                    handleResetGroup={handleResetGroup}
                                  />
                                )}
                              </Col>
                            </Row>
                          </div>
                          {item.itens &&
                            item.itens.map(linha => (
                              <Label
                                style={{
                                  marginLeft: '10px',
                                  color: '#898989',
                                }}
                                key={linha.id}
                              >
                                {linha.descricao}
                                <br />
                              </Label>
                            ))}
                          {item.opcoes.map(opcao => (
                            <BoxRadios
                              key={opcao.id}
                              active={formik.values[item.name] === opcao.value}
                            >
                              <Radio
                                name={item.name}
                                value={formik.values[opcao.value]}
                                checked={
                                  formik.values[item.name] === opcao.value
                                }
                                onChange={() =>
                                  exibeRamificacao1(item.name, opcao.value)
                                }
                              >
                                {opcao.descricao}
                              </Radio>
                            </BoxRadios>
                          ))}
                          {formik.errors[item.name] &&
                          formik.submitCount > 0 ? (
                            <ErrorField message={formik.errors[item.name]} />
                          ) : null}

                          <br />
                          <Alert
                            message="*Considerar equivalente: mudanças hiperagudas nas ondas T, infarto do miocárdio de parede posterior,
                          depressão de ST em várias derivações simultaneamente com supra de ST na derivação aVR, bloqueio de ramo
                          esquerdo e/ou ramo direito na vigência de sintomas agudos."
                            type="info"
                            showIcon
                          />
                        </Row>
                      </div>
                    </BoxInput>
                  ))}
                </Col>
              </Row>

              {ramificacao1 && (
                <>
                  {/* Situação Admissão */}
                  <BoxForm>
                    {situacaoAdmissao.map(item => (
                      <Row key={item.id}>
                        <BoxInput>
                          <Input
                            name={item.name}
                            label={item.label}
                            type="text"
                            value={formik.values[item.name]}
                            hasError={
                              formik.errors[item.name] &&
                              formik.touched[item.name]
                                ? formik.errors[item.name]
                                : ''
                            }
                            maxLength={item.name !== 'creatinina_sca' ? 3 : 4}
                            onChange={({ target }) => {
                              formik.setFieldValue(
                                item.name,
                                item.name !== 'creatinina_sca'
                                  ? onlyNumbers(target.value)
                                  : numbersAndComa(target.value)
                              );
                            }}
                          />
                        </BoxInput>
                      </Row>
                    ))}
                  </BoxForm>

                  {/* Dados SCA */}

                  <BoxForm>
                    <Row>
                      <Col span={24} className="item">
                        {dadosSca.map(item => (
                          <>
                            <RadioInputFlex
                              key={`${item.id}-${item.name}`}
                              item={item}
                              formik={formik}
                            />
                            <hr />
                          </>
                        ))}
                      </Col>
                    </Row>
                  </BoxForm>
                </>
              )}

              {ramificacao1 && (
                <>
                  <BoxForm>
                    <Row>
                      <Col span={24} className="item">
                        {eletrocardiograma.map(item => (
                          <Row>
                            <Row>
                              <Col span={12}>
                                <Label>{item.label}</Label>
                              </Col>
                              <Col span={12}>
                                {isLoaded && (
                                  <ButtonReset
                                    resetGroup={[...eletrocardiograma]}
                                    handleResetGroup={handleResetGroup}
                                  />
                                )}
                              </Col>
                            </Row>
                            <BoxInput key={item.id}>
                              {item.opcoes.map(opcao => (
                                <Col span={12} key={opcao.id}>
                                  <BoxRadios
                                    active={
                                      formik.values[item.name] === opcao.value
                                    }
                                    style={{ maxWidth: '100%' }}
                                  >
                                    <Radio
                                      name={item.name}
                                      value={formik.values[opcao.value]}
                                      checked={
                                        formik.values[item.name] === opcao.value
                                      }
                                      onChange={() =>
                                        formik.setFieldValue(
                                          `${item.name}`,
                                          opcao.value
                                        )
                                      }
                                    >
                                      {opcao.descricao}
                                    </Radio>
                                  </BoxRadios>
                                </Col>
                              ))}
                            </BoxInput>

                            {formik.errors[item.name] &&
                            formik.submitCount > 0 ? (
                              <ErrorField message={formik.errors[item.name]} />
                            ) : null}
                          </Row>
                        ))}
                      </Col>
                    </Row>
                  </BoxForm>
                  <hr />

                  {/* Grace Risk Score */}
                  <BoxForm>
                    <GraceInViewport
                      onEnterViewport={() => {
                        callGraceScore();
                      }}
                      onLeaveViewport={() => console.log('...')}
                    />

                    <Row>
                      <Col span={24}>
                        <Row>
                          <Col span={24} className="item">
                            <BoxInput>
                              <Input
                                name="grace_sca"
                                label="Escore de Grace"
                                type="text"
                                disabled
                                // placeholder="Escore de Grace"
                                value={graceScore || formik.values.grace_sca}
                                hasError={
                                  formik.errors.grace_sca &&
                                  formik.touched.grace_sca
                                    ? formik.errors.grace_sca
                                    : ''
                                }
                                onChange={formik.handleChange}
                              />
                            </BoxInput>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </BoxForm>
                </>
              )}

              {ramificacao1 && (
                <BoxForm>
                  <Row>
                    {tratamentoRealizado.map(item => (
                      <Row>
                        <Row>
                          <Col span={12}>
                            <Label>{item.label}</Label>
                          </Col>
                          <Col span={12}>
                            {isLoaded && (
                              <ButtonReset
                                resetGroup={[...tratamentoRealizado]}
                                handleResetGroup={handleResetGroup}
                              />
                            )}
                          </Col>
                        </Row>
                        <BoxInput key={item.id}>
                          {item.opcoes.map(opcao => (
                            <Col span={12} key={opcao.id}>
                              <BoxRadios
                                active={
                                  formik.values[item.name] === opcao.value
                                }
                                style={{ maxWidth: '100%' }}
                              >
                                <Radio
                                  name={item.name}
                                  value={formik.values[opcao.value]}
                                  checked={
                                    formik.values[item.name] === opcao.value
                                  }
                                  onChange={() =>
                                    exibeRamificacao4(item.name, opcao.value)
                                  }
                                >
                                  {opcao.descricao}
                                </Radio>
                              </BoxRadios>
                            </Col>
                          ))}
                        </BoxInput>

                        {formik.errors[item.name] && formik.submitCount > 0 ? (
                          <ErrorField message={formik.errors[item.name]} />
                        ) : null}
                      </Row>
                    ))}
                  </Row>
                </BoxForm>
              )}

              {ramificacao4 && (
                <>
                  {/* Terapia Fibrinolítica */}
                  <Col span={24}>
                    <Row>
                      <h4>
                        18{')'} Data e hora da realização da terapia
                        fibrinolítica
                      </h4>
                    </Row>
                    <BoxForm>
                      <Row>
                        <Col span={24}>
                          <Row>
                            {terapiaFibrinolitica.map(item => (
                              <Col span={12} className="item" key={item.id}>
                                <DadoFaltantes
                                  title={item.label}
                                  name={item.name}
                                  formik={formik}
                                  errors={formik.errors}
                                  hasError={
                                    formik.errors[item.name] &&
                                    formik.submitCount > 0
                                      ? formik.errors[item.name]
                                      : ''
                                  }
                                />
                              </Col>
                            ))}
                          </Row>
                        </Col>
                      </Row>
                    </BoxForm>
                  </Col>
                  <hr />
                </>
              )}

              {/* Angioplastia */}
              {ramificacao5 && (
                <>
                  <Col span={24}>
                    <Row>
                      <h4>
                        19{')'} Data e hora da realização da angioplastia
                        primária
                      </h4>
                    </Row>
                    <BoxForm>
                      <Row>
                        <Col span={24}>
                          <Row>
                            {angioplastia.map(item => (
                              <Col span={12} className="item" key={item.id}>
                                <DadoFaltantes
                                  title={item.label}
                                  name={item.name}
                                  formik={formik}
                                  errors={formik.errors}
                                  hasError={
                                    formik.errors[item.name] &&
                                    formik.submitCount > 0
                                      ? formik.errors[item.name]
                                      : ''
                                  }
                                />
                              </Col>
                            ))}
                          </Row>
                        </Col>
                      </Row>
                    </BoxForm>
                  </Col>
                  <hr />
                </>
              )}

              {ramificacao1 && (
                <>
                  <BoxForm>
                    <Row>
                      <Col span={24}>
                        <Row>
                          <Col span={24} className="item">
                            {fracaoDeEjecao.map(item => (
                              <Col span={24} className="item" key={item.id}>
                                <DadoFaltantes
                                  title={item.label}
                                  name={item.name}
                                  formik={formik}
                                  defaultValue="0"
                                  firstReason={false}
                                  secondReason="Não realizado"
                                  maxLength={3}
                                  onlyNumber
                                  noPlaceHolder
                                  hasError={
                                    formik.errors[item.name] &&
                                    formik.submitCount > 0
                                      ? formik.errors[item.name]
                                      : ''
                                  }
                                />
                              </Col>
                            ))}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </BoxForm>

                  <BoxForm>
                    <Row>
                      {paliativos.map(item => (
                        <Row>
                          <Row>
                            <Col span={12}>
                              <Label>{item.label}</Label>
                            </Col>
                            <Col span={12}>
                              {isLoaded && (
                                <ButtonReset
                                  resetGroup={[...paliativos]}
                                  handleResetGroup={handleResetGroup}
                                />
                              )}
                            </Col>
                          </Row>
                          <BoxInput key={item.id}>
                            {item.opcoes.map(opcao => (
                              <Col span={12} key={opcao.id}>
                                <BoxRadios
                                  active={
                                    formik.values[item.name] === opcao.value
                                  }
                                  style={{ maxWidth: '100%' }}
                                >
                                  <Radio
                                    name={item.name}
                                    value={formik.values[opcao.value]}
                                    checked={
                                      formik.values[item.name] === opcao.value
                                    }
                                    onChange={() =>
                                      formik.setFieldValue(
                                        `${item.name}`,
                                        opcao.value
                                      )
                                    }
                                  >
                                    {opcao.descricao}
                                  </Radio>
                                </BoxRadios>
                              </Col>
                            ))}
                          </BoxInput>

                          {formik.errors[item.name] &&
                          formik.submitCount > 0 ? (
                            <ErrorField message={formik.errors[item.name]} />
                          ) : null}
                        </Row>
                      ))}
                    </Row>
                  </BoxForm>
                </>
              )}

              <BoxForm>
                <Row>
                  <Col span={24}>
                    <Row>
                      <Col span={12}>
                        <TitleSection>{'>'} Dados da saída</TitleSection>
                      </Col>
                    </Row>
                    {covidSca.map(item => (
                      <Row>
                        <Row>
                          <Col span={12}>
                            <Label>{item.label}</Label>
                          </Col>
                          <Col span={12}>
                            {isLoaded && (
                              <ButtonReset
                                resetGroup={[...covidSca]}
                                handleResetGroup={handleResetGroup}
                              />
                            )}
                          </Col>
                        </Row>
                        <BoxInput key={item.id}>
                          {item.opcoes.map(opcao => (
                            <Col key={opcao.id}>
                              <BoxRadios
                                active={
                                  formik.values[item.name] === opcao.value
                                }
                                style={{ maxWidth: '100%' }}
                              >
                                <Radio
                                  name={item.name}
                                  value={formik.values[opcao.value]}
                                  checked={
                                    formik.values[item.name] === opcao.value
                                  }
                                  onChange={() =>
                                    formik.setFieldValue(
                                      `${item.name}`,
                                      opcao.value
                                    )
                                  }
                                >
                                  {opcao.descricao}
                                </Radio>
                              </BoxRadios>
                            </Col>
                          ))}
                        </BoxInput>

                        {formik.errors[item.name] && formik.submitCount > 0 ? (
                          <ErrorField message={formik.errors[item.name]} />
                        ) : null}
                      </Row>
                    ))}
                  </Col>
                </Row>
              </BoxForm>

              {ramificacao1 && (
                <>
                  <BoxForm>
                    <Row>
                      <Col span={24}>
                        {motivoSaida.map(item => (
                          <RadioInputFlex
                            key={`${item.id}-${item.name}`}
                            item={item}
                            formik={formik}
                          />
                        ))}
                      </Col>
                    </Row>
                    <hr />

                    {/* Data e hora da saída */}
                    <Col span={24}>
                      <BoxForm>
                        <Row>
                          <Col span={24}>
                            <Row>
                              <h4>24) Data e hora da saída</h4>
                            </Row>
                            <Row>
                              {saidaEmergencia.map(item => (
                                <Col span={12} className="item" key={item.id}>
                                  <DadoFaltantes
                                    title={item.label}
                                    name={item.name}
                                    formik={formik}
                                    errors={formik.errors}
                                    hasError={
                                      formik.errors[item.name] &&
                                      formik.submitCount > 0
                                        ? formik.errors[item.name]
                                        : ''
                                    }
                                  />
                                </Col>
                              ))}
                            </Row>
                          </Col>
                        </Row>
                      </BoxForm>
                    </Col>
                    <hr />

                    {/* Medicações prescritas na alta */}
                    <BoxForm>
                      <Row>
                        <Row>
                          <Col span={12}>
                            <h4>25) Medicações prescritas na alta</h4>
                          </Col>
                        </Row>
                        {medicacoesAlta.map(item => (
                          <Row>
                            <Row>
                              <Col span={12}>
                                <Label>{item.label}</Label>
                              </Col>
                              <Col span={12}>
                                {isLoaded && (
                                  <ButtonReset
                                    resetGroup={[...medicacoesAlta]}
                                    handleResetGroup={handleResetGroup}
                                  />
                                )}
                              </Col>
                            </Row>
                            <BoxInput key={item.id}>
                              {item.opcoes.map(opcao => (
                                <Col span={12} key={opcao.id}>
                                  <BoxRadios
                                    active={
                                      formik.values[item.name] === opcao.value
                                    }
                                    style={{ maxWidth: '100%' }}
                                  >
                                    <Radio
                                      name={item.name}
                                      value={formik.values[opcao.value]}
                                      checked={
                                        formik.values[item.name] === opcao.value
                                      }
                                      onChange={() =>
                                        formik.setFieldValue(
                                          `${item.name}`,
                                          opcao.value
                                        )
                                      }
                                    >
                                      {opcao.descricao}
                                    </Radio>
                                  </BoxRadios>
                                </Col>
                              ))}
                            </BoxInput>

                            {formik.errors[item.name] &&
                            formik.submitCount > 0 ? (
                              <ErrorField message={formik.errors[item.name]} />
                            ) : null}
                          </Row>
                        ))}
                      </Row>
                    </BoxForm>
                    <hr />
                  </BoxForm>
                </>
              )}

              {/* Seguimento */}
              {ramificacao3 && (
                <Row>
                  <TitleSection>{'>'} Seguimento</TitleSection>

                  {reinternacao.map(item => (
                    <div key={item.id}>
                      <Row>
                        <Col span={20}>
                          <Label>{item.label}</Label>
                        </Col>
                        <Col span={4}>
                          {isLoaded && (
                            <ButtonReset
                              resetGroup={[...reinternacao]}
                              handleResetGroup={handleResetGroup}
                            />
                          )}
                        </Col>
                      </Row>

                      <Row>
                        {item.itens &&
                          item.itens.map(linha => (
                            <Label
                              style={{
                                marginLeft: '10px',
                                color: '#898989',
                              }}
                              key={linha.id}
                            >
                              {linha.descricao}
                              <br />
                            </Label>
                          ))}
                        <Row>
                          {item.opcoes.map(opcao => (
                            <Col span={4}>
                              <BoxRadios
                                key={opcao.id}
                                active={
                                  formik.values[item.name] === opcao.value
                                }
                              >
                                <Radio
                                  name={item.name}
                                  value={formik.values[opcao.value]}
                                  checked={
                                    formik.values[item.name] === opcao.value
                                  }
                                  onChange={() =>
                                    exibeRamificacao2(item.name, opcao.value)
                                  }
                                >
                                  {opcao.descricao}
                                </Radio>
                              </BoxRadios>
                            </Col>
                          ))}
                        </Row>
                        {formik.errors[item.name] && formik.submitCount > 0 ? (
                          <ErrorField message={formik.errors[item.name]} />
                        ) : null}
                      </Row>
                    </div>
                  ))}
                </Row>
              )}

              {ramificacao2 && (
                <BoxForm>
                  <Row>
                    <Col span={24}>
                      {reinternacaoMotivo.map(item => (
                        <RadioInputFlex
                          key={`${item.id}-${item.name}`}
                          item={item}
                          formik={formik}
                        />
                      ))}
                    </Col>
                  </Row>
                  <hr />
                </BoxForm>
              )}

              <ButtonBox>
                <button type="button" onClick={callHandleSubmit}>
                  {loading ? 'Enviando dados...' : 'Salvar'}
                </button>
              </ButtonBox>
            </form>
          </Content>
        </BoxContent>
      )}
    </>
  );
};

FichadeColetaSCA.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      indicador: PropTypes.string,
      indicadorNome: PropTypes.string,
      periodo: PropTypes.string,
    }),
  }).isRequired,
};

export default FichadeColetaSCA;
